// extracted by mini-css-extract-plugin
module.exports = {"categoriesContainer":"styles_categoriesContainer__Y3NLm","categoriesRow":"styles_categoriesRow__gHNr8"};